import React from 'react';
import { Box, styled } from '@mui/material';

const StyledDashboardBlockContainer = styled(({ showLogo, sxStyles, ...otherProps }) => (
  <Box {...otherProps} />
))(({ showLogo, sxStyles, theme }) => ({
  backgroundColor: theme.palette.surface.content,
  border: `1px solid ${theme.palette.hairline.main}`,
  borderRadius: '16px',
  boxShadow: `inset 0 1px 0 ${theme.palette.innerHighlight}, ${theme.palette.shadow.card}`,
  padding: theme.spacing(2),
  overflow: showLogo ? 'hidden' : 'auto',
  position: 'relative',
  ...sxStyles,
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(3)
  }
}));

export default StyledDashboardBlockContainer;
